// SF2 — the rupee figure on money that is not working.
//
// Split on purpose. Money that bought nothing is waste in full. Money that
// bought sales too expensively is waste only in the part spent beyond target —
// the sales were worth paying for, that much was not. Adding the two as though
// they were the same thing is the mistake this split exists to prevent.
import React from 'react';
import s from '../AdsHealth.module.css';
import { money, num } from '../format';

export default function Waste({ data, currency, findings }) {
  if (!data) return <p className={s.empty}>Loading…</p>;
  if (!data.total_waste) {
    return (
      <p className={s.empty}>
        {data.headline}. {data.split_note}
      </p>
    );
  }

  return (
    <div>
      <div className={s.stats}>
        <div className={s.stat}>
          <span className={s.statValue}>{money(data.total_waste, currency)}</span>
          <span className={s.statLabel}>wasted in the window</span>
        </div>
        <div className={s.stat}>
          <span className={s.statValue}>{money(data.no_sale_waste, currency)}</span>
          <span className={s.statLabel}>
            bought nothing · {num(data.no_sale_count)} terms and targets
          </span>
        </div>
        <div className={s.stat}>
          <span className={s.statValue}>{money(data.over_target_waste, currency)}</span>
          <span className={s.statLabel}>
            beyond target · {num(data.over_target_count)} that did sell
          </span>
        </div>
      </div>
      <p className={s.coverage}>{data.split_note}</p>

      {!!(data.rollup?.by_campaign || []).length && (
        <>
          <h3 className={s.sectionTitle}>Where it is going</h3>
          <div className={s.tableWrap}>
            <table className={s.table}>
              <thead><tr><th>Campaign</th><th className={s.right}>Waste</th></tr></thead>
              <tbody>
                {data.rollup.by_campaign.map((r) => (
                  <tr key={r.campaign}>
                    <td>{r.campaign}</td>
                    <td className={s.right}>{money(r.waste, currency)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className={s.coverage}>
            Rolled up from the rows below, never measured separately — a campaign total
            taken on its own would eventually disagree with the terms under it.
          </p>
        </>
      )}

      <h3 className={s.sectionTitle}>Every wasting term and target</h3>
      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>What</th><th>Where</th><th className={s.right}>Spend</th>
              <th className={s.right}>Sales</th><th className={s.right}>Waste</th>
              <th>Why</th>
            </tr>
          </thead>
          <tbody>
            {(findings || []).map((f) => (
              <tr key={f.id}>
                <td>
                  <span className={s.term}>{f.entity}</span>
                  <div className={s.thin}>
                    {f.level === 'search_term' ? 'search term' : 'target'}
                    {f.detail?.match_type ? ` · ${f.detail.match_type.toLowerCase()}` : ''}
                  </div>
                </td>
                <td className={s.thin}>
                  {f.detail?.campaign}
                  {f.detail?.ad_group ? ` › ${f.detail.ad_group}` : ''}
                </td>
                <td className={s.right}>{money(f.detail?.spend, currency)}</td>
                <td className={s.right}>{money(f.detail?.ad_sales, currency)}</td>
                <td className={s.right}><strong>{money(f.impact, currency)}</strong></td>
                <td className={s.thin} style={{ maxWidth: 420 }}>{f.evidence}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
